import areTheSameDate from 'utils/dateAndTimes/methods/areTheSameDate';

const isDateToday = (date, timezone) =>
  areTheSameDate(date, new Date(), timezone);

export default isDateToday;
